import { inject, Injectable } from "@angular/core";
import { Database } from "@angular/fire/database";
import { Router } from "@angular/router";

@Injectable({
  providedIn: 'root',
})
export class RouteValidatorService {
  private readonly router = inject(Router);
  // private readonly eventDataService = inject(EventDataService);
  private readonly db = inject(Database);

  constructor() {
    // this.router.events.pipe(
    //   filter((e): e is ActivationEnd => e instanceof ActivationEnd),
    //   filter(e => !!e.snapshot?.component),
    //   switchMap(e => {
    //     const snap = e.snapshot;
    //     const eventKey = snap.params?.['eventKey'];
    //     const teamNumber = snap.params?.['teamNumber'];
    //     const key = snap.queryParams?.['key'];

    //     let validators: Observable<{message: string, eventKey: string}>[] = [];
    //     if(eventKey) {
    //       validators.push(this.eventDataService.getEventName(eventKey).pipe(filter(n => !n), map(() => ({message: 'Event not found', eventKey}))));

    //       if(snap.data?.['checkEventEnded']) {
    //         validators.push(this.eventDataService.hasEventEnded(eventKey).pipe(filter(ended => ended), map(() => ({message: EVENT_ENDED_MESSAGE, eventKey}))));
    //       }

    //       if(teamNumber) {
    //         validators.push(objectVal(ref(this.db, `events/${eventKey}/teams/${teamNumber}`)).pipe(filter(k => k === null), map(() => ({message: `${teamNumber} is not in team list`, eventKey}))));

    //         if(key) {
    //           validators.push(objectVal(ref(this.db, `events/${eventKey}/teamNotifications/${teamNumber}/${key}/key`)).pipe(filter(k => k !== key), map(() => ({message: 'Invalid URL', eventKey}))));
    //         } else {
    //           if(snap.data?.['keyRequired']) {
    //             return of({message: 'Invalid URL', eventKey});
    //           }
    //         }
    //       }
    //     }

    //     return race(validators);
    //   }),
    // ).subscribe(message => {
    //   if(message.message === EVENT_ENDED_MESSAGE) {
    //     this.router.navigateByUrl(`/event/${message.eventKey}/event-ended`);
    //   } else {
    //     this.router.navigateByUrl(`/error?message=${message.message}&details=${message.eventKey}`);
    //   }
    // });
  }
}
